import { indexData } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full mb-3">
            内容导航
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            {indexData.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexData.items.map((item) => (
            <a
              key={item.title}
              href={item.link}
              className="group bg-background-100 rounded-lg p-5 no-underline block hover:bg-background-200/70 transition-colors"
            >
              <div className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-lg mb-3">
                <i className={`${item.icon} text-accent-500 text-lg`}></i>
              </div>
              <div className="flex items-center gap-2 mb-1">
                <h3 className="font-heading text-sm font-bold text-foreground-900">
                  {item.title}
                </h3>
                <span className="text-xs text-primary-500 font-medium">{item.count}</span>
              </div>
              <p className="text-xs text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}